import { options } from "./diseasesList";

import Doctor4 from "../assets/patientClinic/Doctor4.png";
import { ReactComponent as LifeStyle } from "../assets/patientClinic/LifeStyle.svg";
import { ReactComponent as Diet } from "../assets/patientClinic/Diet.svg";
import { ReactComponent as Fitness } from "../assets/patientClinic/Fitness.svg";
import { ReactComponent as Bilrubin } from "../assets/patientClinic/Bilrubin.svg";
import { ReactComponent as Fasting } from "../assets/patientClinic/Fasting.svg";
import { ReactComponent as Home } from "../assets/patientClinic/Main.svg";
import { ReactComponent as Doctors } from "../assets/patientClinic/Doctors.svg";
import { ReactComponent as DcotorEnable } from "../assets/patientClinic/DcotorEnable.svg";
import { ReactComponent as HomeInactive } from "../assets/patientClinic/HomeInactive.svg";

export const DEFAULT_SUMMARY_LIST_DISPLAY_COUNT = 1;
export const DEV_BASE_URL = "https://eira-dev.wemotive.in";
export const PROD_BASE_URL = "https://eira-app.dxai.life";

export const API_ENDPOINT = {
  GET_ALL_DISEASE_PREDICTIONS:
    "https://madmachines.datasyndicate.in/v1/api/disease_predictions",
  GET_ALL_SCORES_PREDICTIONS:
    "https://madmachines.datasyndicate.in/v1/api/score_recommendations",
  SAVE_SCORE:
    "https://madmachines.datasyndicate.in/v1/api/save_score_question_response",
  SAVE_USER_DETAILS:
    "https://madmachines.datasyndicate.in/v1/api/save_user_details",
  GET_USER_DETAILS:
    "https://madmachines.datasyndicate.in/v1/api/get_user_details",
  GET_USER_DETAILS_STRAPI:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/user-report-individual-details",
  GET_ANSWER_COUNTS_PERCENTAGE:
    "https://madmachines-api-32xupa3pnq-el.a.run.app/v1/api/answered_counts_percentage",
  GET_SCORE_LABELS: "https://madmachines.datasyndicate.in/v1/api/score_labels",
  SAVE_REPORTS:
    "https://madmachines-api-32xupa3pnq-el.a.run.app/v1/api/save_reports",
  GET_SCORE_QUESTIONS:
    "https://madmachines.datasyndicate.in/v1/api/scores_questions",
  CREATE_CLINIC_USER:
    "https://madmachines.datasyndicate.in/v1/api/get_reports_url",
  UPLOAD_DOCUMENTS: "https://madmachines.datasyndicate.in/v1/api/save_images",
  GET_VIKRITI_RECOMMENDATIONS:
    "https://madmachines.datasyndicate.in/v1/api/get_vikruti_recommendations",
  GET_VIKRITI_ANALYSIS:
    "https://madmachines.datasyndicate.in/v1/api/get_vikruti_analysis",
  SAVE_MEDIA_FOR_ANALYSIS:
    "https://madmachines.datasyndicate.in/v1/api/save_media_for_analysis",
  TRIGGER_ANALYSIS:
    "https://madmachines.datasyndicate.in/v1/api/trigger_analysis_for_blood_report",
  GET_AYURVEDA_CORRELATION:
    "https://madmachines.datasyndicate.in/v1/api/get_similar_shlokas",
  UPDATE_USER_DETAILS:
    "https://madmachines.datasyndicate.in/v1/api/update_user_details",
  GET_INDIVIDUAL_SCORE_QUESTION_RESPONSE:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/score-question-responses",
  GET_SYMTOM_SUGGESTIONS:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/symptoms",
  SAVE_SYMPTOM_SUGGESTIONS:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/user-symptom-histories",
  GET_USER_REPORT_UPLODS:
    "https://madmachines-api-32xupa3pnq-el.a.run.app/v1/api/get_images_for_user",
  GET_ALL_DOCTORS: `${PROD_BASE_URL}/api/department/caregivers/all`,
  BOOK_APPOINTMENTS: `${PROD_BASE_URL}/api/appointments/integration`,
  GET_ALL_APPOINTMENTS_FOR_USER: `${PROD_BASE_URL}/api/appointments/integration/all`,
  GET_USER_SYMPTOMS:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/user-symptom-histories",
  GET_USER_PRESCRIPTION: `${PROD_BASE_URL}/api/patient/prescription/all`,
  GET_BLOOD_REPORT_VALUE:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/individual-blood-report-readings",
  IMAGE_ANALYSIS_STORE:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/image-analysis-stores",
  UPDATE_IMAGE_ANALYSIS_STORE:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/image-analysis-stores/",
  GET_DOCTOR_SLOT: `${PROD_BASE_URL}/api/slots`,
  GET_LATEST_APPT: `${PROD_BASE_URL}/api/latestAppointment`,
  DELETE_USER_DETAILS_STRAPI:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/user-report-individual-details",
  DELETE_USER_SYMPTOMS_STRAPI:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/user-symptom-histories",
  DELETE_Score_QUESTION_RESPONSE_STRAPI:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/score-question-responses",
  DELETE_IMAGE_ANALYSIS_STORE:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/image-analysis-stores",
  DELETE_NANDI_BLOOD_PARAMETERS:
    "https://madmachines-auth-layer-prod.dataorc.workers.dev/api/nandi-blood-report-readings",
  DOWNLOAD_PDF_REPORT:
    "https://pdf-renderer-570770707801.asia-south1.run.app/v1/eira/report/download",
  DONWLOAD_PRESCRITPION_PDF:
    "https://pdf-renderer-570770707801.asia-south1.run.app/v1/eira/prescription/download",
};

export const prodClient = "dxAiPatientClinic";
export const devClient = "dxAiPatientClinic-stage";

export const visibleScoreswithCustomers = {
  healthians: [
    "Physical Activity Score",
    "Metabolic Score",
    "Sleep Score",
    "Stress Score",
    "Fatty Liver Score",
  ],
  onquest: [
    "Physical Activity Score",
    "Metabolic Score",
    "Sleep Score",
    "Stress Score",
    "Fatty Liver Score",
    "Prakriti Score",
    "Vikriti",
  ],
  dxAi: [
    "Physical Activity Score",
    "Sleep Score",
    "Stress Score",
    "Vikriti",
    "Prakriti",
  ],
  dxAiCorporate: ["Prakriti"],

  // patient clinic
  "dxAiPatientClinic-stage": [
    "Physical Activity Score",
    "Sleep Score",
    "Stress Score",
    "Vikriti",
    "Prakriti",
  ],
};

// export const clinicCorporate = [
//   "Basic Details", // save_user_details
//   "Birth Details", // save_user_details
//   "Basic Vitals", // save_user_details
//   "Medical History1", // save_user_details
//   "Symptoms", // MS_3
// ];
// let isClinicCorprate = true;
export const dxaiQuestions = [
  "DxAi_1",
  "DxAi_9",
  "MS_1",
  "MS_2",
  "MS_3",
  "MS_4",
] as const;

export const clinicCorporate = [
  "Basic Details", // save_user_details
  "Birth Details", // save_user_details
  "Basic Vitals", // save_user_details
  "Medical History1", // save_user_details
  "MS_1", // "Family History", //MS_1
  "MS_3", // "Symptoms", // MS_3
  "Upload",
  "Scores",
];

export const questions = [
  // ...(isClinicCorprate ? clinicCorporate : []),
  "Basic Details", // save_user_details
  "Birth Details", // save_user_details
  "Basic Vitals", // save_user_details
  "Medical History1", // save_user_details
  "Symptoms", // MS_3
  "Chief Complaints", // DxAi_ type questions - DxAi_11
  "DxAi_1",
  "DxAi_2",
  "DxAi_3",
  "DxAi_4",
  "Family History", //MS_1
  "Medical History2", // MS_4
  "Upload Report", //image_type:  'tongue', 'prescription', 'blood_report', 'other'
  "DxAi_5",
  "DxAi_6",
  "DxAi_7",
  "DxAi_8",
  "DxAi_9",
  "DxAi_10",
  "Scores",
];

export const dxaiQuestion = {
  // Medical History
  DxAi_12: {
    question_id: "DxAi_12",
    question_text:
      "Have you been diagnosed with any of the following conditions?",
    question_type: "Checkbox_Search",
    question_values: options,
  },
};

// patient clinic
export const clinicScreens = [
  "OtpLoginVerification",
  // two screens in one
  "BasicDetails",
  // screen1-(name, email, dob), screen2-(place of birth)
  "Onboarding",
  // welcome to dxai page- If user is new / relogged in then this page is shown.
  // And if the user is already logged in then check then check the loalstorage if isVisited is true or not. If true then show the dashboard else show the onboarding page.->visited else not visited and show this page
  "Symptom",
  // This screen is also shown after the onboarding page.
  "MeidcalHistory",
  // This will only be show when the user is new.
  "Summary",
  // here we will show the tests : Prakriti and Astral will remain constant. And rest will keep changing.
  // This screen will be shown after every time Symptom is visited
  "Home",
  // This is dynamic and will have many features and routes
];

export interface Symptom {
  label: string;
  value?: string;
  type?: string;
  field: string;
  options?: { label?: string; value?: string; subText?: string }[];
  multiple?: boolean; // For fields that can have multiple selections
  subText?: string; // Optional subText for additional context
  question_id?: string;
}

export const symptomQuestions: Symptom[][] = [
  [
    {
      label: "Who is this assessment for?",
      field: "userType",
      type: "select",
      options: [{ label: "Self", value: "Self" }],
    },
  ],
  [
    {
      label: "Let’s start with the symptom that is bothering you the most:",
      field: "symptom",
      type: "select",
      multiple: true,
      options: [
        { label: "Symptom 1", value: "Symptom 1" },
        { label: "Symptom 2", value: "Symptom 2" },
        { label: "Symptom 3", value: "Symptom 3" },
      ],
    },
    {
      label: "How long has this been bothering you?",
      field: "duration",
      type: "select",
      options: [
        { label: "less_than_one_day", value: "Less than one day" },
        { label: "more_than_a_week", value: "More than a week" },
        { label: "more_than_a_year", value: "More than a year" },
      ],
    },
    {
      label: "How would you describe the intensity of your symptom?",
      field: "intensity",
      type: "select",
      options: [
        {
          label: "mild",
          value: "Mild",
          subText:
            "It’s noticeable but doesn’t interfere much with daily activities.",
        },
        {
          label: "moderate",
          value: "Moderate",
          subText:
            "It’s bothersome and affects some activities, but manageable.",
        },
        {
          label: "severe",
          value: "Severe",
          subText: "It’s intense and significantly impacts your daily life.",
        },
      ],
    },
    {
      label:
        "Please select the frequency of the symptom in a day, if applicable.",
      field: "frequency",
      type: "select",
      options: [
        { label: "once_or_twice_a_day", value: "Once or twice a day" },
        { label: "a_few_times_a_day", value: "A few times a day" },
        { label: "several_times", value: "Several times throughout the day" },
        {
          label: "almost_all_day",
          value: "Almost all day or without relief",
        },
        { label: "not_applicable", value: "Not Applicable" },
      ],
    },
    {
      label: "Please mention anything that helps relieve your symptoms.",
      field: "relieveSymptom",
      type: "text",
      subText: "",
    },
    {
      label: "Please mention anything that worsens your symptoms.",
      field: "worsenSymptom",
      type: "text",
      subText: "",
    },
  ],
  [
    {
      label: "Do you have any other symptoms?",
      field: "otherSymptoms",
      type: "select",
      options: [
        { label: "yes", value: "Yes" },
        { label: "no", value: "No" },
      ],
      subText: "",
    },
  ],
];

export const newSymptomQuestions: Symptom[][] = [
  [
    {
      label: "Who is this assessment for?",
      field: "userType",
      type: "select",
      options: [{ label: "Self", value: "Self" }],
    },
  ],
  [
    {
      label: "Let’s start with the symptom that is bothering you the most:",
      field: "symptom",
      type: "type",
      multiple: true,
      options: [
        { label: "Symptom 1", value: "Symptom 1" },
        { label: "Symptom 2", value: "Symptom 2" },
        { label: "Symptom 3", value: "Symptom 3" },
      ],
    },
    {
      label: "How long have you had this symptom?",
      field: "duration",
      type: "select",
      question_id: "SY_1",
      options: [
        { label: "Less than a week", value: "Less than a week" },
        { label: "1-4 weeks", value: "1-4 weeks" },
        { label: "1-3 months", value: "1-3 months" },
        { label: "More than 3 months", value: "More than 3 months" },
        {
          label: "Comes and goes (intermittent)",
          value: "Comes and goes (intermittent)",
        },
        { label: "Not sure", value: "Not sure" },
      ],
    },
    {
      label: "How would you describe the intensity of your symptoms?",
      field: "intensity",
      type: "select",
      question_id: "SY_2",
      options: [
        {
          label: "Mild",
          value: "Mild",
          subText:
            "It’s noticeable but doesn’t interfere much with daily activities.",
        },
        {
          label: "Moderate",
          value: "Moderate",
          subText:
            "It’s bothersome and affects some activities, but manageable.",
        },
        {
          label: "Severe",
          value: "Severe",
          subText: "It’s intense and significantly impacts your daily life.",
        },
        {
          label: "Very Severe",
          value: "Very Severe",
          subText: "It’s intense and significantly impacts your daily life.",
        },
        {
          label: "Fluctuating",
          value: "Fluctuating",
          subText: "It’s intense and significantly impacts your daily life.",
        },
        {
          label: "Not Sure",
          value: "Not Sure",
          subText: "It’s intense and significantly impacts your daily life.",
        },
      ],
    },
  ],
];

export const routes = {
  // about Eira app
  AboutEira: "/about-eira",
  Consent: "/user-consent",

  // language selection
  LanguageSelection: "/language",

  Login: "/login",
  BasicDetails: "/basic-details",
  Symptom: "/",
  SymptomForm: "/symptom-form",
  RecommendedTests: "/recommended-tests",
  HealthHistory: "/health-history",
  PrakritiTest: "/prakriti-test",
  PrakritiResponse: "/prakriti-response",
  AyurvedaCorrelation: "/ayurveda-correlation",

  // vikriti
  VikritiAnalysis: "/vikriti-analysis",

  // tongue
  TongueAnalysis: "/tongue-analysis",
  LabReports: "/lab-reports",
  LabReportsUpload: "/lab-reports-upload",
  RecommendedTestsLabReport: "blood-test",
  RecommendedTestsLabReportWithCart: "/user-recommended-tests",
  // new tongue
  TongueAnalysisNew: "/tongue-analysis",
  TongueAnalysisUpload: "/upload",
  TongueAnalysisTakePicture: "/take-picture",

  AstralHealth: "/astral-health",
  HealthScores: "/health-scores",
  ScoreResult: "/score-result",
  ReportTrends: "/report-trends",

  AboutTest: "/about-test",

  // disease report
  DiseaseReport: "/report",

  //appointment
  Appointment: "/appointment",
  ViewAllDoctors: "/appointment/view-all-doctors",
  DcotorsProfile: "/appointment/doctors-profile",
  BookTimeSlot: "/appointment/book-time-slot",
  AppointmentSummary: "/appointment/appointment-summary",
  AppointmentDetails: "/appointment/appointment-details",
  UpcomingAppointments: "/appointment/upcoming-appointments",
  CancelAppointment: "/appointment/cancel-appointment",
  CancelAppointmentConfirmation: "/appointment/cancel-appointment-confirmation",

  //dashboard
  Dashboard: "/dashboard",
  CheckList: "/check-list",

  // medicines
  Medicines: "/medicines",

  // tests
  Tests: "/tests",

  // sideDrawer
  Profile: "/profile",

  // review-health-scores-answers-wrapper
  ReviewAnswers: "/review-answers",

  // panchkarma
  PanchKarmaLandingScreen: "/panchkarma",
  PanchkarmaCenter: "/panchkarma-centers",
  PanchkarmaDateSelection: "/select-date",
  PanchkarmaRoomSelection: "/room-booking",
  AddAddress: "/add-address",
  AddLoction: "/select-location",
  Payment: "/payment",
  AddCard: "/add-card",
  PanchkarmaAppointmentDetails: "/panchkarma-appointment-details",

  // panchkarma-review
  TreatmentOverView: "/treatment-overview",
  FirstConsultationReport: "/first-consultation-report",
  SymptomRating: "/symptom-rating",
  PanchkarmaDailySchedule: "/panchkarma-daily-schedule",
  PanchkarmaDailyScheduleFood: "/panchkarma-daily-schedule-food",
  PanchkarmaDailyScheduleMedicine: "/panchkarma-daily-schedule-medicine",
  PanchkarmaDailyScheduleMantra: "/panchkarma-daily-schedule-mantra",
  PanchkarmaDailyScheduleKriya: "/panchkarma-daily-schedule-kriya",

  FaceCaptur: "/face-capture",

  Prescription: "/user-prescription",

  DownloadReport: "/download-pdf",
  SymtpomsList: "/symtoms/all",
  TermsCondition: "/terms-and-condtions",
  PrivacyProlicy: "/privacy-policy",
};

export const headerTypes = {
  tests: "tests",
  base: "base",
  dashboard: "dashboard",
  none: "none",
};

export type DxAiQuestionKeys = (typeof dxaiQuestions)[number];

export const fixedScoreQuestion = ["Physical Activity Score", "Sleep Score"];

export const userProfileScores = ["Stress Score"];

// export const doctorsDetailList = [
//   {
//     id: 1,
//     name: "Dr. Aarti Jain",
//     specialization: ["Gynaecologist", "Obstetrician", "Irregular Periods"],
//     experience: 8,
//     qualifications: "MBBS, MD",
//     distance: 5,
//     location: "Malviya Nagar",
//     clinic: "Eira Clinic, New Delhi",
//     fee: 1000,
//     rating: 4.5,
//     availability: true,
//     symptoms: ["Hypertension", "Breathing Problems"],
//     image: Doctor1,
//   },
//   {
//     id: 2,
//     name: "Dr. Neha Gulati",
//     specialization: ["Gynaecologist", "Obstetrician"],
//     experience: 15,
//     qualifications: "MBBS, MD",
//     distance: 2,
//     location: "Malviya Nagar",
//     clinic: "Eira Clinic, New Delhi",
//     fee: 1500,
//     rating: 4.8,
//     availability: false,
//     symptoms: ["Hypertension"],
//     image: Doctor3,
//   },
//   {
//     id: 3,
//     name: "Dr. Hemant Kumar",
//     specialization: ["General Physicaian", "Cardiologist"],
//     experience: 10,
//     qualifications: "MBBS, MS",
//     distance: 8,
//     location: "Saket",
//     clinic: "Saket Clinic, New Delhi",
//     fee: 800,
//     rating: 4.0,
//     availability: true,
//     symptoms: ["Indigestion", "Acidity", "Headache", "Coronavirus"],
//     image: Doctor1,
//   },
//   {
//     id: 4,
//     name: "Dr. Aditi Kumari",
//     specialization: ["Allergist and Clinical Immunologist", "Anaesthesia"],
//     experience: 10,
//     qualifications: "MBBS, MS",
//     distance: 8,
//     location: "Saket",
//     clinic: "Gurgaon, New Delhi",
//     fee: 800,
//     rating: 4.0,
//     availability: true,
//     symptoms: ["Headache"],
//     image: Doctor3,
//   },
//   {
//     id: 5,
//     name: "Dr. Amrit Singh",
//     specialization: ["Anaesthesia"],
//     experience: 10,
//     qualifications: "MBBS, MS",
//     distance: 8,
//     location: "Saket",
//     clinic: "Saket Clinic, New Delhi",
//     fee: 800,
//     rating: 4.0,
//     availability: true,
//     symptoms: ["Headache"],
//     image: Doctor1,
//   },

//   {
//     id: 5,
//     name: "Dr. Anumpan Mishra",
//     specialization: ["Orthopaedician"],
//     experience: 10,
//     qualifications: "MBBS, MS",
//     distance: 8,
//     location: "Saket",
//     clinic: "Saket Clinic, New Delhi",
//     fee: 800,
//     rating: 4.0,
//     availability: true,
//     symptoms: ["Joint Pain", "Back Pain"],
//     image: Doctor3,
//   },
//   {
//     id: 6,
//     name: "Dr. Ekta Sharma",
//     specialization: ["Gynaecologist", "Obstetrician"],
//     experience: 12,
//     qualifications: "MBBS, DM",
//     distance: 3,
//     location: "Malviya Nagar",
//     clinic: "Eira Clinic, New Delhi",
//     fee: 1200,
//     rating: 4.7,
//     availability: true,
//     symptoms: ["Irregular Periods", "Acidity"],
//     image: Doctor2,
//   },
// ];

export const doctorsDetailList = [
  {
    id: 1,
    name: "Dr. Tanmay Goswami",
    specialization: [
      "Ayurveda",
      "Medical Astrology",
      "Panchakarma",
      "Rasayana",
    ],
    experience: 25,
    qualifications: "MD, PhD",
    distance: 5,
    location:
      "Mayur Vihar, Delhi, Govardhan Dham, Uttar Pradesh, Udupi, Karnataka",
    clinic: "Gosval Clinic",
    fee: 2000,
    rating: 5,
    availability: true,
    symptoms: ["Holistic Healing", "Detoxification", "Rejuvenation"],
    treatmentServices: [
      "Panchakarma Therapy",
      "Rasayana Therapy",
      "Medical Astrology",
      "Herbal Medicines",
      "Holistic Healing",
      "Preventive Healthcare",
      "Diet & Lifestyle Guidance",
      "Mind-Body Wellness",
    ],
    image: Doctor4,
  },
];

export const scoreImageMap = (scoreName: string): string => {
  const scoreToPath: Record<string, string> = {
    "Physical Activity Score": "/assets/new-scores/physical_activity_score.svg",
    "Stress Score": "/assets/new-scores/stress_score.svg",
    "Sleep Score": "/assets/new-scores/sleep_score.svg",
    "Social Avoidance Scale": "/assets/new-scores/social_avoidance_scale.svg",
    "Fatty Liver Score": "/assets/new-scores/fatty_liver_score.svg",
    "Metabolic Score": "/assets/new-scores/metabolic_score.svg",
    "General Anxiety Score": "/assets/new-scores/general_anxiety_score.svg",
    "Drug Abuse Screening Test":
      "/assets/new-scores/drug_abuse_screening_test.svg",
    "Patient Health Questionnaire":
      "/assets/new-scores/patient_health_questionnaire.svg",
    "Job Stress Scale": "/assets/new-scores/job_stress_score.svg",
    "Fantastic Lifestyle Checklist":
      "/assets/new-scores/fantastic_lifestyle_checklist.svg",
    "WHO WellBeing Index (WHO5)": "/assets/new-scores/who_wellbeing_index.svg",
    "Social Health Score": "/assets/new-scores/social_health_score.svg",
    "Insomnia Assessment Index":
      "/assets/new-scores/insomnia_assessment_index.svg",
    "Sleepiness Scale": "/assets/new-scores/sleepiness_scale.svg",
    "Dietary Pattern Assessment":
      "/assets/new-scores/dietary_pattern_assessment.svg",
    "Mood Disorder Questionnaire":
      "/assets/new-scores/mood_disorder_questionnaire.svg",
    "PTSD Checklist": "/assets/new-scores/ptsd_checklist.svg",
    "Obsessive Compulsive Inventory":
      "/assets/new-scores/obsessive_compulsive_inventory.svg",
    "Adolescent Substance Abuse Screening":
      "/assets/new-scores/adolescent_substance_abuse_screening.svg",
    "Obstructive Sleep Apnea Assessment":
      "/assets/new-scores/obstructive_sleep_apnea_assessment.svg",
    "Asthma Control Test": "/assets/new-scores/asthma_control_test.svg",
    "COPD Assessment": "/assets/new-scores/copd_assessment.svg",
    "Internet Addiction Test": "/assets/new-scores/internet_addiction_test.svg",
    "Smoking Dependency": "/assets/new-scores/smoking_dependency.svg",
  };

  return (
    scoreToPath[scoreName] || "/assets/new-scores/physical_activity_score.svg"
  );
};

export const scoreQuestionMap = (scoreName: string) => {
  switch (scoreName) {
    case "Physical Activity Score":
      return "Total Questions 6-9";
    case "Stress Score":
      return "Total Questions 10";
    case "Sleep Score":
      return "Total Questions 16";
    case "Social Avoidance Scale":
      return "Total Questions 28";
    case "Fatty Liver Score":
      return "Total Questions 3";
    case "Metabolic Score":
      return "Total Questions 3";
    case "General Anxiety Score":
      return "Total Questions 7";
    case "Drug Abuse Screening Test":
      return "Total Questions 10";
    case "Patient Health Questionnaire":
      return "Total Questions 9";
    case "Job Stress Scale":
      return "Total Questions 8";
    case "Fantastic Lifestyle Checklist":
      return "Total Questions 25";
    case "WHO WellBeing Index (WHO5)":
      return "Total Questions 5";
    case "Social Health Score":
      return "Total Questions 20";
    case "Insomnia Assessment Index":
      return "Total Questions 7";
    case "Sleepiness Scale":
      return "Total Questions 8";
    case "Dietary Pattern Assessment":
      return "Total Questions 16";
    case "Mood Disorder Questionnaire":
      return "Total Questions 17";
    case "PTSD Checklist":
      return "Total Questions 20";
    case "Obsessive Compulsive Inventory":
      return "Total Questions 18";
    case "Adolescent Substance Abuse Screening":
      return "Total Questions 9";
    case "Obstructive Sleep Apnea Assessment":
      return "Total Questions 8";
    case "Asthma Control Test":
      return "Total Questions 5";
    case "COPD Assessment":
      return "Total Questions 8";
    case "Internet Addiction Test":
      return "Total Questions 20";
    case "Smoking Dependency":
      return "Total Questions 6";
    default:
      return "Total Questions 6";
  }
};

export const healthScoreGroups = [
  [
    {
      name: "Physical Activity Score",
      logo: scoreImageMap("Physical Activity Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Stress Score",
      logo: scoreImageMap("Stress Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Sleep Score",
      logo: scoreImageMap("Sleep Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Social Avoidance Scale",
      logo: scoreImageMap("Social Avoidance Scale"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    // {
    //   name: "Fatty Liver Score",
    //   logo: scoreImageMap("Fatty Liver Score"),
    //   hasFilled: false,
    // hasPartiallyFilled:false,
    // },
    // {
    //   name: "Metabolic Score",
    //   logo: scoreImageMap("Metabolic Score"),
    //   hasFilled: false,
    // hasPartiallyFilled:false,
    // },
    {
      name: "General Anxiety Score",
      logo: scoreImageMap("General Anxiety Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Drug Abuse Screening Test",
      logo: scoreImageMap("Drug Abuse Screening Test"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Patient Health Questionnaire",
      logo: scoreImageMap("Patient Health Questionnaire"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Job Stress Scale",
      logo: scoreImageMap("Job Stress Scale"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Fantastic Lifestyle Checklist",
      logo: scoreImageMap("Fantastic Lifestyle Checklist"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "WHO WellBeing Index (WHO5)",
      logo: scoreImageMap("WHO WellBeing Index (WHO5)"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Social Health Score",
      logo: scoreImageMap("Social Health Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Insomnia Assessment Index",
      logo: scoreImageMap("Insomnia Assessment Index"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Sleepiness Scale",
      logo: scoreImageMap("Sleepiness Scale"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Dietary Pattern Assessment",
      logo: scoreImageMap("Dietary Pattern Assessment"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    // {
    //   name: "Mood Disorder Questionnaire",
    //   logo: scoreImageMap("Mood Disorder Questionnaire"),
    //   hasFilled: false,
    //   hasPartiallyFilled: false,
    // },
    {
      name: "PTSD Checklist",
      logo: scoreImageMap("PTSD Checklist"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Obsessive Compulsive Inventory",
      logo: scoreImageMap("Obsessive Compulsive Inventory"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Adolescent Substance Abuse Screening",
      logo: scoreImageMap("Adolescent Substance Abuse Screening"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Obstructive Sleep Apnea Assessment",
      logo: scoreImageMap("Obstructive Sleep Apnea Assessment"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Asthma Control Test",
      logo: scoreImageMap("Asthma Control Test"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "COPD Assessment",
      logo: scoreImageMap("COPD Assessment"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Dyspnea Scale",
      logo: scoreImageMap("Dyspnea Scale"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Internet Addiction Test",
      logo: scoreImageMap("Internet Addiction Test"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Smoking Dependency",
      logo: scoreImageMap("Smoking Dependency"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
  ],
];

export const dailyAccessScores = [
  [
    {
      name: "Physical Activity Score",
      logo: scoreImageMap("Physical Activity Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Sleep Score",
      logo: scoreImageMap("Sleep Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Dietary Pattern Assessment",
      logo: scoreImageMap("Dietary Pattern Assessment"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
    {
      name: "Stress Score",
      logo: scoreImageMap("Stress Score"),
      hasFilled: false,
      hasPartiallyFilled: false,
    },
  ],
];

export const activeAnalysis = [
  [
    {
      name: "Tongue Analysis",
      logo: "/assets/tongue.svg",
      route: routes.TongueAnalysisUpload,
      resultRoue: `${routes.ScoreResult}/Tongue Analysis`,
    },
    {
      name: "Prakriti",
      logo: "/assets/new-scores/physical_activity_score.svg",
      route: routes.PrakritiTest,
      resultRoue: `${routes.ScoreResult}/Prakriti`,
    },

    // {
    //   name: "Organ Score",
    //   logo: PhysicalActivityScore,
    //   route: null,
    //   resultRoue: null,
    // },
  ],
];

export const healthRecommendations = [
  { name: "LifeStyle", logo: LifeStyle },
  { name: "Diet", logo: Diet },
  { name: "Fitness", logo: Fitness },
];

export const articlesForYou = [
  { name: "What is Bilirubin?", logo: Bilrubin },
  { name: "Intermittent Fasting", logo: Fasting },
  { name: "What is Bilirubin?", logo: Bilrubin },
];

export const footerRoutes = [
  {
    name: "Home",
    route: routes.Dashboard,
    ActiveIcons: Home,
    InActiveicons: HomeInactive,
  },
  {
    name: "Doctors",
    route: routes.Appointment,
    ActiveIcons: DcotorEnable,
    InActiveicons: Doctors,
  },
  // {
  //   name: "Medicines",
  //   route: routes.Medicines,
  //   ActiveIcons: Medicines,
  //   InActiveicons: Medicines,
  // },
  // {
  //   name: "Tests",
  //   route: routes.Tests,
  //   ActiveIcons: Tests,
  //   InActiveicons: Tests,
  // },
];

export const sampleShloka: any = {
  Vomiting: [
    {
      id: 1,
      attributes: {
        shloka:
          "अथ छर्दिनिदानम्|\nछर्दिर्दोषैः पृथक्सर्वैर्द्विष्टैरर्थैश्च पञ्चमी|\nउदानो विकृतो दोषान् सर्वास्वप्यूर्ध्वमस्यति||",
        meaning:
          "Vomiting cause by Udana (division of vata) which has become abnormal aggravates all the doshas and makes them move upwards. ",
        cause: "Udana vayu",
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Vagbhata",
        sthana_name: "Nidana",
        chapter_number: 5,
        shloka_num: 30,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
        symptoms_text: null,
      },
    },
    {
      id: 2,
      attributes: {
        shloka:
          "तासूत्क्लेशास्यलावण्यप्रसेकारुचयोऽग्रगाः|\nनाभिपृष्ठं रुजन् वायुः पार्श्वे चाहारमुत्क्षिपेत्||",
        meaning:
          "Vata produces vomitting of food, causing pain in the umbilicus, back and flanks",
        cause: null,
        prodromal_symptoms:
          "Nausea, salt taste in the mouth, more of salivation and loss of taste and appetite",
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Vagbhata",
        sthana_name: "Nidana",
        chapter_number: 5,
        shloka_num: 31,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
    {
      id: 3,
      attributes: {
        shloka:
          "मनःशिलायाः फलपूरकस्य रसैः कपित्थस्य च पिप्पलीनाम्|\nक्षौद्रेण चूर्णं मरिचैश्च युक्तं लिहञ्जयेच्छर्दिमुदीर्णवेगाम्||",
        meaning:
          "The following recipes subdue the forcefully generated urge for vomiting:\n\n1. Powder of (purified) manahsila with the juice of bija-puraka, honey and powder of maricha; and\n\n2. Powder of pippali mixed with the juice of kapittha, honey and the powder of maricha",
        cause: null,
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Charak",
        sthana_name: "Chikitsa",
        chapter_number: 20,
        shloka_num: 39,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
        symptoms_text: null,
      },
    },
    {
      id: 4,
      attributes: {
        shloka:
          "गन्धा विचित्रा मनसोऽनुकूला मृत्पुष्पशुक्ताम्लफलादिकानाम्|\nशाकानि भोज्यान्यथ पानकानि सुसंस्कृताः षाडवरागलेहाः||",
        meaning:
          " He should be made to smell various types of pleasing perfumes emanating from the earth, flowers, sukta (vinegar) and sour fruits;\nHe should be given to eat well prepared vegetables, eatables, syrups, sadavas (pickles), raga (condiments) and lehas (preparations in the form of linctus or jam)\n",
        cause: null,
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: "Eat well prepared vegetables, eatables, syrups, sadavas (pickles), raga (condiments) and lehas (preparations in the form of linctus or jam)",
        fluids: null,
        lifestyle:
          "Smell various types of pleasing perfumes emanating from the earth, flowers, sukta (vinegar) and sour fruits",
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Charak",
        sthana_name: "Chikitsa",
        chapter_number: 20,
        shloka_num: 42,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
  ],
  Diarrhea: [
    {
      id: 5,
      attributes: {
        shloka:
          "रूक्षाल्पप्रमिताशिनस्तीक्ष्णमद्यव्यवायनित्यस्योदावर्तयतश्च वेगान् वायुः प्रकोपमापद्यते, पक्ता चोपहन्यते; स वायुः कुपितोऽग्नावुपहते मूत्रस्वेदौ पुरीषाशयमुपहृत्य, ताभ्यां पुरीषं द्रवीकृत्य, अतीसाराय प्रकल्पते|\nतस्य रूपाणि- विज्जलमामं विप्लुतमवसादि रूक्षं द्रवं सशूलमामगन्धमीषच्छब्दमशब्दं वा विबद्धमूत्रवातमतिसार्यते पुरीषं, ",
        meaning:
          "1. Exposure to the excessively strong wind, hot sun and physical exercise;\n\n2. Indulgence in ununctuous food or less quantity of food or irregular meals (pramitasana) or strong alcoholic drinks or excessive sexual intercourse; and\n\n3. Suppression of natural urges.\n",
        cause:
          "Exposure to the excessively strong wind, hot sun and physical exercise;\n\nIndulgence in ununctuous food or less quantity of food or irregular meals (pramitasana) or strong alcoholic drinks or excessive sexual intercourse;\n\nSuppression of natural urges.\n",
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Charak",
        sthana_name: "Chikitsa",
        chapter_number: 19,
        shloka_num: 5,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
    {
      id: 6,
      attributes: {
        shloka:
          "पिप्पली पिप्पलीमूलं चित्रकं हस्तिपिप्पली|\nयोगाञ्छ्लोकार्धविहितांश्चतुरस्तान् प्रयोजयेत्||",
        meaning:
          "Pippali, pippali-mula, chitraka and gaja-pippali.\n\nadministration of the decoction of the following four recipes cures diarrhea",
        cause: null,
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle:
          "Pippali, pippali-mula, chitraka and gaja-pippali.\n\nadministration of the decoction of the following four recipes cures diarrhea",
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Charak",
        sthana_name: "Chikitsa",
        chapter_number: 19,
        shloka_num: 106,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
    {
      id: 7,
      attributes: {
        shloka:
          "तक्रेणावन्तिसोमेन यवाग्वा तर्पणेन वा|\nसुरया मधुना चादौ यथासात्म्यमुपाचरेत्||",
        meaning:
          " butter-milk, avanti-soma or kanji (a sour drink), yavagu (thick gruel), tarpana (roasted flour of serials mixed with water) or honey",
        cause: null,
        prodromal_symptoms: null,
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids:
          " butter-milk, kanji (a sour drink), yavagu (thick gruel), tarpana (roasted flour of serials mixed with water) or honey",
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Charak",
        sthana_name: "Chikitsa",
        chapter_number: 19,
        shloka_num: 24,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
    {
      id: 8,
      attributes: {
        shloka:
          "दोषावस्थास्तस्य नैकप्रकाराः काले काले व्याधितस्योद्भवन्ति |\nहृन्नाभिपायूदरकुक्षितोदगात्रावसादानिलसन्निरोधाः ||",
        meaning:
          "Piercing pain in the regions of the heart, umbilicus, rectum, abdomen and in the Kuksi ( sides of the abdomen), a sense of numbness in the limbs, stoppage or supression of flatus ",
        cause: null,
        prodromal_symptoms:
          "Piercing pain in the regions of the heart, umbilicus, rectum, abdomen and in the Kuksi ( sides of the abdomen), a sense of numbness in the limbs, stoppage or supression of flatus ",
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Sushruta",
        sthana_name: "Uttaratantra",
        chapter_number: 40,
        shloka_num: 8,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
    {
      id: 9,
      attributes: {
        shloka:
          "विट्सङ्ग आध्मानमथाविपाको भविष्यतस्तस्य पुरःसराणि |\nशूलाविष्टः सक्तमूत्रोऽन्त्रकूजी स्रस्तापानः सन्नकट्यूरुजङ्घः ||",
        meaning:
          "Supression of flatus and of stool, distension of the abdomen, and indigestion ,sula (colic pain), suppression of urine, rumbling sound in the intestines.  Pain  in the waist, in the thighs and in the legs ",
        cause: null,
        prodromal_symptoms:
          "Supression of flatus and of stool, distension of the abdomen, and indigestion ,sula (colic pain), suppression of urine, rumbling sound in the intestines.  Pain  in the waist, in the thighs and in the legs ",
        differential_diagnosis: null,
        treatment_principle: null,
        medicine_name: null,
        medicine_type: null,
        food: null,
        fluids: null,
        lifestyle: null,
        method_of_herbal_preparation: null,
        purvakarma: null,
        Panchkarma_Pradhan_karma: null,
        paschat_karma: null,
        upadrava: null,
        prognosis: null,
        prayaya: null,
        indications: null,
        dosha: null,
        dushya: null,
        agni: null,
        contraindication: null,
        kshaya: null,
        vriddhi: null,
        sop: null,
        ritucharya: null,
        description: null,
        psychological_factors: null,
        specification: null,
        organ_body_part: null,
        srotas: null,
        dincharya: null,
        combinations: null,
        pariksha: null,
        exceptions: null,
        createdAt: null,
        updatedAt: null,
        publishedAt: null,
        book_name: "Sushruta",
        sthana_name: "Uttaratantra",
        chapter_number: 40,
        shloka_num: 9,
        symptom_name: null,
        type_name: null,
        pathogenesis_name: null,
        medicine_type_name: null,
        food_name: null,
        fluid_name: null,
        method_name_of_herbal_preparation: null,
        purvakarma_name: null,
        pradhan_karma_name: null,
        prognosis_name: null,
        dosha_name: null,
        dushya_name: null,
        agni_name: null,
        kshaya_name: null,
        vriddhi_name: null,
        ritucharya_name: null,
        psychological_factor_name: null,
        organ_body_part_name: null,
        srota_name: null,
        pariksha_name: null,
        dosha_text: null,
        dushya_text: null,
        food_text: null,
        fluid_text: null,
        psychological_factor_text: null,
        pradhan_karma_text: null,
        types_text: null,
      },
      symptoms_text: null,
    },
  ],
};

export const recommendedTests = [
  {
    title: "Lipid Profile",
    biomarkers: "8",
    description:
      "Measures cholesterol and triglyceride levels to assess heart disease risk.",
    isAdded: false,
  },
  {
    title: "Liver Function Test (LFT)",
    biomarkers: "11",
    description:
      "Evaluates liver health by measuring enzymes, proteins, and bilirubin.",
    isAdded: true,
  },
  {
    title: "Kidney Function Test (KFT/RFT)",
    biomarkers: "7",
    description:
      "Checks how well your kidneys are working by measuring urea, creatinine, and more.",
    isAdded: false,
  },

  {
    title: "Thyroid Profile (T3, T4, TSH)",
    biomarkers: "3",
    description:
      "Assesses thyroid gland function and detects hyper/hypothyroidism.",
    isAdded: false,
  },
  {
    title: "Blood Sugar (Fasting/PP/HbA1c)",
    biomarkers: "1-3",
    description:
      "Measures glucose levels and long-term sugar control for diabetes monitoring.",
    isAdded: false,
  },
  {
    title: "Vitamin D (25-OH)",
    biomarkers: "1",
    description: "Detects Vitamin D deficiency affecting bones and immunity.",
    isAdded: false,
  },
  {
    title: "Vitamin B12",
    biomarkers: "1",
    description:
      "Identifies deficiency linked to fatigue, nerve issues, and anemia.",
    isAdded: false,
  },
  {
    title: "Iron Studies / Ferritin",
    biomarkers: "3-5",
    description:
      "Evaluates iron levels, helpful for diagnosing anemia and fatigue.",
    isAdded: false,
  },
  {
    title: "ESR (Erythrocyte Sedimentation Rate)",
    biomarkers: "1",
    description: "Indicates inflammation or chronic conditions.",
    isAdded: false,
  },
  {
    title: "CRP (C-Reactive Protein)",
    biomarkers: "1",
    description: "Detects acute inflammation or infection in the body.",
    isAdded: false,
  },
];

export const additionalTests = [
  { label: "HbA1c Blood", biomarkers: 2 },
  { label: "Liver & Kidney Panel Serum", biomarkers: 23 },
  { label: "Thyroid Profile Total Serum", biomarkers: 3 },
  { label: "Vitamin D 25 - Hydroxy Serum", biomarkers: 1 },
  { label: "Vitamin B12 Cyanocobalamin", biomarkers: 1 },
];

export const screenVarintswithDiferentColor = ["normal", "abouttest"];

export const labsOptions = [
  { key: "Suburban_Lab_Column_Name", uiDisplayValue: "Suburban Lab" },
  { key: "Thyrocare_Lab_Column_Name", uiDisplayValue: "Thyrocare Lab" },
  { key: "SRL_Lab_Column_Name", uiDisplayValue: "SRL Lab" },
  { key: "Healthians_Lab_Column_Name", uiDisplayValue: "Healthians Lab" },
  { key: "Oncquest_Lab_Column_Name", uiDisplayValue: "Oncquest Lab" },
  {
    key: "Apollo_Diagnostics_Column_Name",
    uiDisplayValue: "Apollo Diagnostics",
  },
  { key: "Pathkind _Lab_Column_Name", uiDisplayValue: "Pathkind Lab" },
  { key: "Aster_Labs_Column_Name", uiDisplayValue: "Aster Labs " },
  { key: "TATA_1_MG_Lab_Column_Name", uiDisplayValue: "TATA 1 MG Lab" },
  { key: "Drlogy_Lab_Column_Name", uiDisplayValue: "Drlogy Lab" },
  { key: "Max_Lab_Column_Name", uiDisplayValue: "Max Lab" },
  {
    key: "Sterling_Accuris_Lab_Column_Name",
    uiDisplayValue: "Sterling Accuris",
  },
  { key: "PharmEasy_Lab_Column_Name", uiDisplayValue: "PharmEasy Lab" },
  { key: "HOD_Lab_Column_Name", uiDisplayValue: "HOD Lab" },
  { key: "METROPOLIS_Lab_Column_Name", uiDisplayValue: "METROPOLIS Lab" },
  { key: "Redcliffe_Lab_Column_Name", uiDisplayValue: "Redcliffe Lab" },
  {
    key: "Vijaya_Diagnostic_Centre_Lab_Column_Name",
    uiDisplayValue: "Vijaya Diagnostic Centre Lab",
  },
  {
    key: "Lupin_Diagnostics_Lab_Column_Name",
    uiDisplayValue: "Lupin Diagnostics",
  },
  {
    key: "BIOGENE_LABS",
    uiDisplayValue: "Biogene Labs",
  },
  {
    key: "Other",
    uiDisplayValue: "Other",
  },
];

export const reportTypes = [
  { key: "blood_report", uiDisplayValue: "Blood Report" },
  { key: "usg", uiDisplayValue: "USG" },
  {
    key: "x_rays",
    uiDisplayValue: "X Rays",
  },
  { key: "stool", uiDisplayValue: "Stool" },
  { key: "ct_scans", uiDisplayValue: "CT Scans" },
  { key: "mri_scans", uiDisplayValue: "MRI Scans" },
  { key: "mammography", uiDisplayValue: "Mammography " },
  { key: "pet_scan", uiDisplayValue: "PET Scan" },
  { key: "dexa_scan", uiDisplayValue: "DEXA Scan" },
  { key: "ecg", uiDisplayValue: "ECG" },
  {
    key: "colonoscopy",
    uiDisplayValue: "Colonoscopy",
  },
  { key: "pap_smear", uiDisplayValue: " Pap Smear" },
  { key: "biopsy", uiDisplayValue: "Biopsy" },
  { key: "hsg", uiDisplayValue: "HSG" },
  { key: "karyotyping", uiDisplayValue: "Karyotyping" },
  {
    key: "doppler_studies",
    uiDisplayValue: "Doppler_Studies",
  },
  { key: "hair", uiDisplayValue: "Hair" },
];

export const employment_status = [
  { code: "SAL", label: "Salaried Employee" },
  { code: "SELF", label: "Self-Employed" },
  { code: "BUS", label: "Business Owner" },
  { code: "FREE", label: "Freelancer" },
  { code: "HOME", label: "Homemaker/Housewife" },
  { code: "PART", label: "Part-time Worker" },
  { code: "STU", label: "Student" },
  { code: "RET", label: "Retired" },
  { code: "UN", label: "Unemployed" },
  { code: "CAS", label: "Casual Worker" },
  { code: "INT", label: "Intern/Trainee" },
];

export const employment_type = [
  {
    SAL: [
      { code: "IT", label: "Information Technology" },
      { code: "DOC", label: "Doctor/Medical Professional" },
      { code: "ENG", label: "Engineer" },
      { code: "TCH", label: "Teacher/Professor" },
      { code: "NUR", label: "Nurse" },
      { code: "LAW", label: "Lawyer/Legal Professional" },
      { code: "ACC", label: "Accountant/CA" },
      { code: "BNK", label: "Banking/Finance" },
      { code: "MKT", label: "Marketing/Sales" },
      { code: "HR", label: "Human Resources" },
      { code: "ARC", label: "Architect" },
      { code: "DES", label: "Designer" },
      { code: "PHR", label: "Pharmacist" },
      { code: "GOV", label: "Government Service" },
      { code: "POL", label: "Police/Defense" },
      { code: "LAB", label: "Lab Technician" },
      { code: "MAN", label: "Manager/Executive" },
      { code: "OTH_SAL", label: "Other Salaried Job" },
    ],
  },
  {
    BUS: [
      { code: "RETAIL", label: "Retail Business" },
      { code: "MANUF", label: "Manufacturing Business" },
      { code: "REST", label: "Restaurant/Food Business" },
      { code: "REAL_EST", label: "Real Estate Business" },
      { code: "TRANS", label: "Transport Business" },
      { code: "WHOLE", label: "Wholesale Business" },
      { code: "AGRI_BUS", label: "Agriculture Business" },
      { code: "SERV_BUS", label: "Service Business" },
      { code: "TECH_BUS", label: "Technology Business" },
      { code: "OTH_BUS", label: "Other Business" },
    ],
  },
  {
    SELF: [
      { code: "DOC_PVT", label: "Private Practice Doctor" },
      { code: "LAW_PVT", label: "Private Practice Lawyer" },
      { code: "ACC_PVT", label: "Private Practice CA/Accountant" },
      { code: "CON", label: "Consultant" },
      { code: "TUT_PVT", label: "Private Tutor/Coaching" },
      { code: "ARCH_PVT", label: "Independent Architect" },
      { code: "PHOTO", label: "Photographer" },
      { code: "EVENT", label: "Event Planner" },
      { code: "CLINIC", label: "Clinic Owner" },
      { code: "OTH_SELF", label: "Other Self-Employed Professional" },
    ],
  },
  {
    FREE: [
      { code: "FR_IT", label: "Freelance Developer/IT" },
      { code: "FR_DES", label: "Freelance Designer" },
      { code: "FR_WRT", label: "Freelance Writer" },
      { code: "FR_PHO", label: "Freelance Photographer" },
      { code: "FR_CON", label: "Freelance Consultant" },
      { code: "FR_TUT", label: "Freelance Tutor" },
      { code: "FR_MKT", label: "Freelance Marketer" },
      { code: "FR_VID", label: "Video Editor/Creator" },
      { code: "FR_TRANS", label: "Freelance Translator" },
      { code: "FR_OTH", label: "Other Freelance Work" },
    ],
  },
  {
    HOME: [
      { code: "HW_FULL", label: "Full-time Homemaker" },
      { code: "HW_1", label: "House-wife" },
      { code: "HW_TUT", label: "Homemaker + Home Tuition" },
      { code: "HW_SEW", label: "Homemaker + Tailoring/Stitching" },
      { code: "HW_COOK", label: "Homemaker + Home Cooking/Catering" },
      { code: "HW_ART", label: "Homemaker + Arts/Crafts" },
      { code: "HW_BEAUTY", label: "Homemaker + Beauty Services" },
      { code: "HW_ONL", label: "Homemaker + Online Work" },
      { code: "HW_CHILD", label: "Homemaker + Childcare Services" },
      { code: "HW_OTH", label: "Homemaker + Other Activities" },
    ],
  },
  {
    PART: [
      { code: "PT_RETAIL", label: "Part-time Retail" },
      { code: "PT_TUTOR", label: "Part-time Tutor" },
      { code: "PT_DELIVER", label: "Part-time Delivery" },
      { code: "PT_CLEAN", label: "Part-time Cleaning" },
      { code: "PT_CARE", label: "Part-time Caregiver" },
      { code: "PT_DATA", label: "Part-time Data Entry" },
      { code: "PT_SALES", label: "Part-time Sales" },
      { code: "PT_FOOD", label: "Part-time Food Service" },
      { code: "PT_ADMIN", label: "Part-time Admin Work" },
      { code: "PT_OTH", label: "Other Part-time Work" },
    ],
  },
  {
    STU: [
      { code: "STU_SCH", label: "School Student" },
      { code: "STU_UG", label: "Undergraduate Student" },
      { code: "STU_PG", label: "Postgraduate Student" },
      { code: "STU_PHD", label: "PhD/Research Student" },
      { code: "STU_PROF", label: "Professional Course Student" },
      { code: "STU_DIPL", label: "Diploma Student" },
      { code: "STU_SKILL", label: "Skill Development Course" },
      { code: "STU_COMP", label: "Competitive Exam Preparation" },
      { code: "STU_OTH", label: "Other Student" },
    ],
  },
  {
    RET: [
      { code: "RET_GOV", label: "Retired Government Employee" },
      { code: "RET_PVT", label: "Retired Private Employee" },
      { code: "RET_MIL", label: "Retired Military/Defense" },
      { code: "RET_BUS", label: "Retired Business Owner" },
      { code: "RET_TEACH", label: "Retired Teacher/Professor" },
      { code: "RET_BANK", label: "Retired Bank Employee" },
      { code: "RET_ENG", label: "Retired Engineer" },
      { code: "RET_DOC", label: "Retired Doctor" },
      { code: "RET_OTH", label: "Other Retired Professional" },
    ],
  },
  {
    UN: [
      { code: "UN_FRESH", label: "Fresh Graduate" },
      { code: "UN_EXP", label: "Experienced Job Seeker" },
      { code: "UN_CAREER", label: "Career Break" },
      { code: "UN_HEALTH", label: "Health-related Break" },
      { code: "UN_FAMILY", label: "Family Responsibilities" },
      { code: "UN_SKILL", label: "Skill Development Phase" },
      { code: "UN_OTH", label: "Other Reason" },
    ],
  },
  {
    CAS: [
      { code: "CAS_LABOR", label: "Daily Wage Laborer" },
      { code: "CAS_CONSTRUCT", label: "Construction Worker" },
      { code: "CAS_FARM", label: "Farm Worker" },
      { code: "CAS_DRIVER", label: "Casual Driver" },
      { code: "CAS_CLEAN", label: "Cleaning Services" },
      { code: "CAS_LOAD", label: "Loading/Unloading" },
      { code: "CAS_PAINT", label: "Painter" },
      { code: "CAS_GARDEN", label: "Gardener" },
      { code: "CAS_VENDOR", label: "Street Vendor" },
      { code: "CAS_OTH", label: "Other Casual Work" },
    ],
  },
  {
    INT: [
      { code: "INT_IT", label: "IT Intern" },
      { code: "INT_MED", label: "Medical Intern" },
      { code: "INT_ENG", label: "Engineering Trainee" },
      { code: "INT_MBA", label: "MBA Intern" },
      { code: "INT_BANK", label: "Banking Trainee" },
      { code: "INT_MKT", label: "Marketing Intern" },
      { code: "INT_HR", label: "HR Trainee" },
      { code: "INT_TEACH", label: "Teaching Trainee" },
      { code: "INT_LAW", label: "Law Intern" },
      { code: "INT_OTH", label: "Other Intern/Trainee" },
    ],
  },
];
